import { CollectionOrderBy } from '../enums';


export const CollectionsOrderBy = [
  { name: 'Custom', value: CollectionOrderBy.Custom },
  { name: 'Alphabetical', value: CollectionOrderBy.Alphabetical },
  { name: 'Randomized', value: CollectionOrderBy.Randomized },
];
